module.exports = __webpack_public_path__ + "static/media/22_tn.effd47d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/22_tn.jpg
// module id = 452
// module chunks = 0